import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfirmEmailResponse } from '../models/confirm-email.model';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class ConfirmEmailService {
  private readonly API_URL = '/user';
  private apiService = inject(ApiService);


  confirmEmail(token: string): Observable<ConfirmEmailResponse> {
    return this.apiService.get<ConfirmEmailResponse>(
      `${this.API_URL}/registration/${token}`
    );
  }
}
